import { render, staticRenderFns } from "./FileDetailsPanel.vue?vue&type=template&id=8491810a&scoped=true&"
import script from "./FileDetailsPanel.vue?vue&type=script&lang=js&"
export * from "./FileDetailsPanel.vue?vue&type=script&lang=js&"
import style0 from "./FileDetailsPanel.vue?vue&type=style&index=0&id=8491810a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8491810a",
  null
  
)

export default component.exports